import contactForm from '../modules/contact-form';
import customersMiniList from '../modules/customers-mini-list';

export default {
  init() {
    contactForm.init();
    // Mini-list module.
    customersMiniList.init();
  },
  finalize() {
    contactForm.finalize();
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/routes/templateContactUs.js